export const OutletRoleEnum = Object.freeze({
  RETAIL: 'RETAIL',
  HUB: 'HUB',
});